'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var debug = require('debug');

var utils = require('../../../utils.js');

var errCode = require('err-code');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var log = debug__default["default"]('ipfs:mfs:utils:update-mfs-root');

function updateMfsRoot(_x, _x2, _x3) {
  return _updateMfsRoot.apply(this, arguments);
}

function _updateMfsRoot() {
  _updateMfsRoot = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context, cid, options) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(options && options.signal && options.signal.aborted)) {
              _context.next = 2;
              break;
            }

            throw errCode__default["default"](new Error('Request aborted'), 'ERR_ABORTED', {
              name: 'Aborted'
            });

          case 2:
            log("New MFS root will be ".concat(cid));
            _context.next = 5;
            return context.repo.datastore.put(utils.MFS_ROOT_KEY, cid.bytes);

          case 5:
            return _context.abrupt("return", cid);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _updateMfsRoot.apply(this, arguments);
}

exports.updateMfsRoot = updateMfsRoot;